import { apiGet, apiPost, type ApiResponse } from './genesisApi/httpsMethods';
import { genesisApiRoot } from './genesisApi/genesisApiRoot';

export interface Prompt {
  id: number;
  prompt_key: string;
  prompt_name: string;
  description: string | null;
  prompt_content: string;
  version: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  created_by: string | null;
}

export interface CreateOrUpdatePromptRequest {
  prompt_key: string;
  prompt_name: string;
  description: string | null;
  prompt_content: string;
}

/**
 * List all prompts
 */
export async function getPrompts(): Promise<ApiResponse<Prompt[]>> {
  return apiGet<Prompt[]>('api/prompts');
}

/**
 * Get a single prompt by key
 */
export async function getPrompt(promptKey: string): Promise<ApiResponse<Prompt>> {
  return apiGet<Prompt>(`api/prompts/${promptKey}`);
}

/**
 * Get version history for a prompt
 */
export async function getPromptVersions(promptKey: string): Promise<ApiResponse<Prompt[]>> {
  return apiGet<Prompt[]>(`api/prompts/${promptKey}/versions`);
}

/**
 * Create a new prompt or update existing (creates new version)
 */
export async function createOrUpdatePrompt(
  data: CreateOrUpdatePromptRequest
): Promise<ApiResponse<Prompt>> {
  return apiPost<Prompt>('api/prompts', data);
}

/**
 * Update an existing prompt (creates new version)
 */
export async function updatePrompt(
  promptKey: string,
  data: CreateOrUpdatePromptRequest
): Promise<ApiResponse<Prompt>> {
  const { url, headers } = await genesisApiRoot(`api/prompts/${promptKey}`);
  
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(data),
  });

  const status = response.status;
  try {
    const json = await response.json();
    
    if (!response.ok) {
      return {
        success: false,
        status,
        message: json?.detail || `PUT api/prompts/${promptKey} failed (${status})`,
      };
    }

    return {
      success: true,
      status,
      data: json,
    };
  } catch (e) {
    return {
      success: false,
      status,
      message: `Unexpected response format (${status})`,
    };
  }
}

